import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import { texts } from 'utils/languages/fr';

import { Box, Link } from '@mui/material';

const linkSx =
    hasFinishedSubscription =>
    ({ palette }) => ({
        fontSize: '13px',
        marginRight: '20px',
        textTransform: 'uppercase',
        textDecoration: 'none',
        color: hasFinishedSubscription ? palette.common.black : palette.grey[500],
        '&[disabled]': {
            color: palette.action.disabled,
            pointerEvents: 'none',
        },
    });

const InvestorNavigation = ({
    hasSubscriberSignedBS,
    hasFinishedSubscription,
    isNewSubscription,
    userIsAdminDistributor,
}) => {
    if (!(hasSubscriberSignedBS || (!isNewSubscription && hasFinishedSubscription))) return null;

    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Box display="flex">
                <Link sx={linkSx(true)} href="/dashboard" to="/dashboard" component={RouterLink}>
                    {texts.ACCUEIL}
                </Link>
                <Link
                    disabled={!hasFinishedSubscription}
                    component={hasFinishedSubscription ? RouterLink : 'button'}
                    sx={linkSx(hasFinishedSubscription)}
                    href="/my-account"
                    to="/my-account"
                >
                    {texts.MON_COMPTE}
                </Link>
                <Link
                    disabled={!hasFinishedSubscription}
                    component={hasFinishedSubscription ? RouterLink : 'button'}
                    sx={linkSx(hasFinishedSubscription)}
                    to="/investor-messages"
                    href="/investor-messages"
                >
                    {texts.MY_MESSAGES}
                </Link>
                {!userIsAdminDistributor && (
                    <Link
                        component={RouterLink}
                        sx={linkSx(true)}
                        to="/investor-documents"
                        href="/investor-documents"
                    >
                        {texts.MY_DOCUMENTS}
                    </Link>
                )}
                <Link
                    disabled={!hasFinishedSubscription && hasSubscriberSignedBS}
                    component={
                        hasFinishedSubscription || !hasSubscriberSignedBS ? RouterLink : 'button'
                    }
                    sx={linkSx(hasFinishedSubscription || !hasSubscriberSignedBS)}
                    to="/portfolio"
                    href="/portfolio"
                >
                    {texts.MY_PORTFOLIO}
                </Link>
            </Box>
        </Box>
    );
};

InvestorNavigation.propTypes = {
    hasSubscriberSignedBS: PropTypes.bool,
    hasFinishedSubscription: PropTypes.bool,
    userIsAdminDistributor: PropTypes.bool,
    isNewSubscription: PropTypes.bool,
};

export default InvestorNavigation;
